import LocalizedStrings from 'react-localization';

export const strings = new LocalizedStrings({
    en: {
        home: "Home",
        nextDepartures: "Next Departures",
        nextDeparturesFrom: "Next departures from",
        network: "Network",
        planRoute: "Plan Route",
        schedules: "Schedules",
        schedulesByLine: "Schedules by Line",
        schedulesByStop: "Schedules by Stop",
        schedulesDisclaimer: "The displayed schedules are valid for the present day, other periods may have different schedules",
        messages: "News / Informations",
        ticketOffice: "Ticket Office",
        about: "About",
        searchPlaceholder: "Select (Stop / Line / Ticket Office)",
        originStopPlaceHolder: "Departure",
        destinationStopPlaceHolder: "Arrival",
        destination: "Destination",
        planRouteButton: "Plan Trip",
        plannedRoutes: "Trip options",
        duration: "Duration",
        includes: "Includes",
        changes: "change(s)",
        planRouteTimeFilterSelectNow: "Now",
        planRouteTimeFilterSelectStartDate: "Select departure date",
        planRouteTimeFilterSelectedStartDate: "Departure at",
        planRouteTimeFilterSelectEndDate: "Select arrival date",
        planRouteTimeFilterSelectedEndDate: "Arrival at",
        planRouteTimeDisclaimer: "Travel options more suitable for a maximum interval of up to 4 hours from the selected departure time (4 hours earlier for Arrival at option)",
        checkSchedules: "Check Schedules",
        availableLines: "Lines",
        walkAround: "Walk around",
        estimatedWaitingTime: "Estimated waiting time between",
        arrivalEstimatedAt: "Arrival estimated at",
        and: "and",
        or: "or",
        lineInfoStopsTitle: "Stops",
        lineInfoMoreScheds: "more schedules",
        showStops: "Show stops",
        showSchedule: "Show schedule",
        showTrip: "Show route",
        showMap: "Show map",
        moreSchedsTitle: "Schedules",
        noMessagesToShow: "No messages to show",
        noPassingsToShow: "No passings to show",
        noTripsToShow: "No trips to show",
        noInfoToShow: "No information to show",
        selectDate: "Select date",
        provider: "Provider",
        line: "Line",
        viewLine: "View line",
        selectPath: "Select path",
        direction: "Direction",
        directionGo: "Go",
        directionReturn: "Return",
        directionCircular: "Circular",
        daytype: "Day Type",
        locale: "en",
        hoursFilter: "Filter by hours",
        initialHourFilter: "Start time",
        finalHourFilter: "End time",
        filter: "Filter",
        close: "Close",
        done: "Done",
        copyright: "Powered by OPT",
        allRightsReserved: "All rights reserved",
        privacyPolicy: "Privacy Policy",
        notFoundTitle: "404 - Page not found",
        notFoundDescription: "The page you are trying to access does not exist.",
        developedFor: "Developed for TAC – Transportes do Alentejo Central, S.A",
        contact: "Contact Us",
        name: "Name",
        email: "Email",
        emailWarning: "We'll never share your email with anyone else.",
        subject: "Subject",
        send: "Send",
        general: "General",
        emailSuccess: "Message sent successfully.",
        emailError: "An error occurred, please try again later.",  
        pageNotFound: "Page not found",
        delayed: "Delayed",
        aheadSchedule: "Ahead of schedule",
        complaints: "TRIMBAL Complaints",
        complaintsBook: "Complaints Book",
        phone: "Telephone",
        sendMessage: "Send us a message:",
        seeMore: "See more",
        passengerRights: "Passenger's Rights",
        ticketInfo: "Tickets and fares",
        serviceOnDemand: "Services on demand",
        moreInfoSoon: "More informations soon...",
        fares: "Fares",
        tickets: "TRANSPORT TICKETS",
        landingPageRoutePlanning: "Plan Route",
        landingPageNetwork: "Network",
        landingPageTickets: "Tickets, fares and cards",
        landingPageServiceOnDemand: "Services on demand",
        landingPageContacts: "Contacts",
        simpleTicket: "SIMPLE TICKET",
        kmSteps: "BRACKETS KM",
        full: "FULL",
        half: "HALF",
        code: "CODE",
        driverFare: "DRIVER FARE",
        prePurchased: "PRE-PURCHASED",
        automatedLines: "AUTOMATED LINES",
        lineSubscriptions: "LINE SUBSCRIPTION",
        discount60: "60% discount",
        discount25: "25% discount",
        disclaimer: "The stop times available on the website are those in effect on the current date, subject to future changes. The stop times between towns are merely indicative, therefore you should consider the time for the town that precedes the one you're in.    ",
        contactComplaints: "Complaints",
        contactHeader: "Office / Sales",
        contactHeader2: "Sales",
        contactEveryday: "Everyday 06h00 to 21h00",
        contactExceptSatturday: "Everyday from 06h30 to 20h30",
        contactWorkingDays: "Working days 06h30 to 20h30",
        contactSaturdays: "Saturdays 06h30 to 10h30 / 13h30 to 20h30",
        contactSundays: "Sundays 07h45 to 10h45 / 13h45 to 20h30",
        contactsPrivacyDisclaimer: "The data collected is intended to respond to your request and facilitate contacts between you and Rodoviária do Alentejo, S.A.. Find out more about our ",
        contactsPrivacyCheckbox: "I authorize my data to be used to carry out promotional and direct marketing actions, carried out through automatic calling devices, fax devices, by email, SMS, MMS, or other means that allow the reception of messages regardless of the intervention of the recipients.",
        notes: "View Notes",
        simpleOnBoard: "Simple on Board Ticket",
        fullAndHalf: "Full and Half",
        fullAndHalfConditions: "Details:",
        fullAndHalfConditionA: "Non-personalized;",
        fullAndHalfConditionB: "Sold on board the bus;",
        fullAndHalfConditionC: "Price according to the table.",
        "monthly": "MONTHLY PASS (LINE SUBSCRIPTION)",
        "monthlyConditionsA": "Personalised, personal, and non-transferable ticket",
        "monthlyConditionsB": "Sold at the ticket office",
        "monthlyConditionsC": "Toed up monthly at the ticket office or on board buses",
        "monthlyConditionsD": "Valid for the month and Origin/Destination for which it was purchased, with an unlimited number of journeys",
        "monthlyConditionsE": "Must be validated on board the bus",
        "monthlyRequirements": "Required documents:",
        "monthlyRequirementA": "Citizen Card (ID)",
        "monthlyRequirementB": "1 photograph",
        "passCIM": "CIM SOCIAL PASS",
        "passCIMConditions": "Details:",
        "passCIMConditionA": "Personalised, personal, and non-transferable ticket",
        "passCIMConditionB": "Sold at the ticket office",
        "passCIMConditionC": "Toed up monthly at the ticket office or on board buses",
        "passCIMConditionD": "Valid for the month and Origin/Destination for which it was purchased, with an unlimited number of journeys",
        "passCIMConditionE": "Must be validated on board the bus",
        "passCIMConditionF": "Ticket previously authorized by CIMAC",
        "passCIMConditionG": "Discount compared to the Monthly Pass price",
        "passCIMRequirements": "Required documents:",
        "passCIMRequirementA": "Citizen Card (ID)",
        "passCIMRequirementsB": "1 photograph",
        "pass418s23": "SUB18+TP AND SUB23+TP PASS",
        "pass418Conditions1": "Intended for all children and young people from 4 to 23 years old (inclusive).",
        "pass418Conditions2": "Young people aged between 4 and 23 benefit from this Pass, which is valid until the last day of the month in which they turn 24. This pass does not require annual renewal.",
        "pass418Conditions3": "Application conditions according to Ordinance no. 7-A/2024, of January 05, amended by Ordinance 307-A/2024/1 which regulates free passes).",
        "pass418ConditionA": "Personalised, personal, and non-transferable ticket",
        "pass418ConditionB": "Sold at the ticket office",
        "pass418ConditionC": "Must be validated on board the bus",
        "pass418ConditionD": "Passes are for usual home – school/work travel routes",
        "pass418ConditionE": "Each young person is only entitled to request one free pass",
        "pass418ConditionF": "If the home—school / work travel covers more than one Intermunicipal Community / Metropolitan Area, the passenger must provide proof that they reside and study / work in different and contiguous regions",
        "pass418ConditionFA": "Proof of residence is the Tax Domicile Certificate obtained from the Tax Authority",
        "pass418ConditionFB": "Proof of study is the Enrolment Declaration issued by the educational institution",
        "pass418ConditionFC": "Proof of work is a document proving the workplace issued by the employer",
        "pass418ConditionG": "Passes are valid until the last day of the month in which the holder turns 24 years old",
        "pass418Requirements": "Required documents:",
        "pass418RequirementA": "Completion of the IMT 'Application Form – Free Pass for Young People' (form)",
        "pass418RequirementB": "Presentation of Citizen Card or similar document proving date of birth",
        "pass418RequirementC": "1 photograph",
        "pass418RequirementD": "If it covers more than one Intermunicipal Community / Metropolitan Area (regardless of age), submit proof of usual residence address and enrolment declaration from the educational institution where studying or document proving the workplace issued by the employer, according to Ordinance 307-A/2024/1",
        "pass418Notes": "Notes:",
        "pass418NotesA": "The cost of the new card is borne by the passenger, according to Ordinance 7A/2024",
        "pass418NotesB": "It is mandatory to complete/provide all requested information at the time of purchase, especially the civil identification document (Citizen Card, Passport, etc.) and the Tax Identification Number (NIF). Without these 2 data points, the pass cannot be issued",
        "pass418NotesC": "Even though they are free, passes must always be validated when boarding the bus. Without a pass, an onboard ticket fare will be charged",
        "pass418Renewal": "Must be renewed every year.",
        "passCircula": "CIRCULA PT PASS",
        "passCirculaConditionA": "Personalised, personal, and non-transferable ticket",
        "passCirculaConditionB": "Sold at the ticket office",
        "passCirculaConditionC": "Toed up monthly at the ticket office or on board buses",
        "passCirculaConditionD": "Valid for the month and Origin/Destination for which it was purchased, with an unlimited number of journeys",
        "passCirculaConditionE": "Must be validated on board the bus",
        "passCirculaConditionF": "CIRCULA PT is a pass that guarantees discounts up to 50%",
        "passCirculaConditionG": "This new modality is regulated by Ordinance 322-A/2024/1, which establishes 2 Discount Tiers (A and B) on Public Retail Prices.",
        "passCirculaDiscounts": "Beneficiaries and Discounts",
        "passCirculaDiscountsA": "Tier A – 50% Discount",
        "passCirculaDiscountsAA": "Beneficiaries of the Solidarity Supplement for the Elderly",
        "passCirculaDiscountsAB": "Beneficiaries of the Social Insertion Income",
        "passCirculaDiscountsAC": "Holders of a Multi-use Medical Certificate of Disability (AMIM) with a degree ≥ 60%",
        "passCirculaDiscountsB": "Tier B – 25% Discount",
        "passCirculaDiscountsBA": "Retirees and pensioners with monthly income equal to or less than €644.56",
        "passCirculaDiscountsBB": "Beneficiaries of Unemployment Benefit, Social Unemployment Benefit, Cessation of Activity Benefit, and Professional Cessation of Activity Benefit with a monthly amount equal to or less than €644.56",
        "passCirculaDiscountsBC": "Households with an average monthly income equal to or less than €644.56",
        "passCirculaRequirements": "Required documents:",
        "passCirculaRequirementA": "Citizen Card and Tax Identification Number",
        "passCirculaRequirementB": "1 photograph",
        "passCirculaRequirementC": "Income declaration and tax settlement note (when applicable)",
        "passCirculaRequirementD": "Declaration certifying the number of members in the household",
        "passCirculaRequirementE": "Copy of the AMIM (if applicable)",
        "passAntigoCombatente": "FORMER COMBATANTS PASS",
        "passAntigoCombatenteConditionA": "Personalised, personal, and non-transferable ticket",
        "passAntigoCombatenteConditionB": "Valid for the month and Origin/Destination for which it was purchased, with an unlimited number of journeys",
        "passAntigoCombatenteConditionC": "Must be validated on board the bus",
        "passAntigoCombatenteConditionD": "Intended for all former combatants holding a former combatant card, as well as the widow or widower of a former combatant",
        "passAntigoCombatenteConditionE": "The Former Combatant Pass is subject to monthly top-up/activation",
        "passAntigoCombatenteConditionF": "It can be topped up for the following month from the 25th onwards, and at any time for the current month",
        "passAntigoCombatenteConditionG": "The route that must appear on the pass is from the stop closest to the residence to the usual destination",
        "passAntigoCombatenteConditionH": "The beneficiary of the Former Combatant Pass cannot enjoy more than one free ticket simultaneously",
        "passAntigoCombatenteMoreInfo": "For more information access the following link:",
        "passAntigoCombatenteLink": "Former Combatant Pass (imt-ip.pt)",
        "passAntigoCombatenteRequirements": "Required documents:",
        "passAntigoCombatenteRequirementA": "Citizen card or other equivalent valid ID",
        "passAntigoCombatenteRequirementB": "1 photograph",
        "passAntigoCombatenteRequirementC": "Former combatant card or widow/widower of a former combatant card",
        "passAntigoCombatenteRequirementD": "Duly completed IMT form and the tax domicile certificate issued by the Tax Authority here",
        "ticketsDownload": "Check Ticket Fares"
    },
    pt: {
        home: "Início",
        nextDepartures: "Próximas Partidas",
        nextDeparturesFrom: "Próximas partidas de",
        network: "Rede",
        planRoute: "Planear Rota",
        schedules: "Horários",
        schedulesByLine: "Horários por Linha",
        schedulesByStop: "Horários por Paragem",
        schedulesDisclaimer: "Os horários apresentados são válidos para o dia atual, podendo não ter correspondência para outros períodos",
        messages: "Notícias / Informações",
        ticketOffice: "Posto de Venda",
        about: "Acerca de",
        searchPlaceholder: "Pesquisar (Paragem / Linha / Posto de Venda)",
        originStopPlaceHolder: "Partida",
        destinationStopPlaceHolder: "Chegada",
        destination: "Destino",
        planRouteButton: "Planear Viagem",
        plannedRoutes: "Opções de viagem",
        duration: "Duração",
        includes: "Inclui",
        changes: "transbordo(s)",
        planRouteTimeFilterSelectNow: "Agora",
        planRouteTimeFilterSelectStartDate: "Escolher data de partida",
        planRouteTimeFilterSelectedStartDate: "Partida às",
        planRouteTimeFilterSelectEndDate: "Escolher data de chegada",
        planRouteTimeFilterSelectedEndDate: "Chegada às",
        planRouteTimeDisclaimer: "Opções de viagem mais adequadas para um intervalo máximo de até 4 horas a partir da hora indicada(4 horas antes para opção de Chegada às)",
        checkSchedules: "Consultar Horários",
        availableLines: "Linhas",
        walkAround: "Ir a pé cerca de",
        estimatedWaitingTime: "Tempo de espera estimado entre as",
        arrivalEstimatedAt: "Chegada estimada às",
        and: "e",
        or: "ou",
        lineInfoStopsTitle: "Paragens",
        lineInfoMoreScheds: "mais horários",
        showStops: "Ver paragens",
        showSchedule: "Ver horário",
        showTrip: "Ver viagem",
        showMap: "Ver mapa",
        moreSchedsTitle: "Horários",
        noMessagesToShow: "Sem mensagens",
        noPassingsToShow: "Sem tempos de passagem",
        noTripsToShow: "Sem viagens para mostrar",
        noInfoToShow: "Sem informação para mostrar",
        selectDate: "Selecione uma data",
        provider: "Operador",
        line: "Linha",
        viewLine: "Ver linha",
        selectPath: "Escolha um percurso",
        direction: "Sentido",
        directionGo: "Ida",
        directionReturn: "Volta",
        directionCircular: "Circular",
        daytype: "Tipo de Dia",
        locale: "pt",
        hoursFilter: "Filtrar por horas",
        initialHourFilter: "Hora inicial",
        finalHourFilter: "Hora final",
        filter: "Filtrar",
        close: "Fechar",
        done: "Concluído",
        copyright: "Powered by OPT",
        allRightsReserved: "Todos os direitos reservados",        
        privacyPolicy: "Política de Privacidade",
        notFoundTitle: "404 - Página não encontrada",
        notFoundDescription: "A página à qual está a tentar aceder não existe.",
        developedFor: "Desenvolvido para TAC – Transportes do Alentejo Central, S.A",
        contact: "Contacto",
        name: "Nome",
        email: "Email",
        emailWarning: "O seu endereço nunca será partilhado com mais nenhuma organização.",
        subject: "Assunto",
        send: "Enviar",
        general: "Geral",
        emailSuccess: "Mensagem enviada com sucesso.",
        emailError: "Ocorreu um erro, por favor tente mais tarde.",  
        pageNotFound: "Página não encontrada",
        delayed: "Atrasado",
        aheadSchedule: "Adiantado",
        complaints: "Reclamações TRIMBAL",
        complaintsBook: "Livro de Reclamações",
        phone: "Telefone",
        sendMessage: "Envie-nos uma mensagem:",
        seeMore: "Ver mais",
        passengerRights: "Direitos dos Passageiros",
        ticketInfo: "Títulos e tarifas",
        serviceOnDemand: "Serviços a pedido",
        moreInfoSoon: "Mais informações brevemente...",
        fares: "Tarifário",
        tickets: "TÍTULOS DE TRANSPORTE",
        landingPageRoutePlanning: "Planear rota",
        landingPageNetwork: "Rede",
        landingPageTickets: "Títulos, tarifas e cartões",
        landingPageServiceOnDemand: "Serviços a pedido",
        landingPageContacts: "Contactos",
        simpleTicket: "BILHETE SIMPLES",
        kmSteps: "ESCALÕES KM",
        full: "INTEIRO",
        half: "MEIO",
        code: "CÓD.",
        driverFare: "TARIFA MOTORISTA",
        prePurchased: "PRÉ-COMPRADOS",
        automatedLines: "CARREIRAS AUTOMATIZADAS",
        lineSubscriptions: "ASSINATURA LINHA",
        discount60: "60% desconto",
        discount25: "25% desconto",
        disclaimer: "Os horários disponibilizados no site são os que estão em vigor na data atual, estando sujeitos a alterações futuras. Os horários das paragens entre localidades são meramente indicativos pelo que deverá considerar o horário da localidade que antecede o local onde se encontra.    ",
        contactComplaints: "Reclamações",
        contactHeader: "Instalações / Posto de Venda",
        contactHeader2: "Posto de Venda",
        contactEveryday: "Todos os dias 06h00 às 21h00",
        contactExceptSatturday: "Todos os dias 06h30 às 20h30",
        contactWorkingDays: "Dias úteis 06h30 às 20h30",
        contactSaturdays: "Sábados 06h30 às 10h30 / 13h30 às 20h30",
        contactSundays: "Domingo 07h45 às 10h45 / 13h45 às 20h30",
        contactsPrivacyDisclaimer: "Os dados recolhidos destinam-se a dar resposta ao seu pedido e a facilitar os contactos entre si e a Rodoviária do Alentejo, S.A.. Saiba mais sobre a nossa ",
        contactsPrivacyCheckbox: "Autorizo que os meus dados sejam usados para a realização de ações de promoção e de marketing direto, levadas a cabo através de aparelhos de chamada automática, aparelhos de telecópia, por correio eletrónico, SMS, MMS, ou outros meios que permitam a receção de mensagens independentemente da intervenção dos destinatários.",
        notes: "Ver Notas",
        simpleOnBoard: "Bilhete Simples a Bordo",
        fullAndHalf: "Inteiro e Meio",
        fullAndHalfConditions: "Detalhes:",
        fullAndHalfConditionA: "Título não personalizado;",
        fullAndHalfConditionB: "Vendido a bordo;",
        fullAndHalfConditionC: "Valor de acordo com a tabela tarifária.",
        monthly: "PASSE MENSAL (ASSINATURA DE LINHA)",
        monthlyConditionsA: "Título personalizado, pessoal e intransmissível",
        monthlyConditionsB: "Vendido na bilheteira",
        monthlyConditionsC: "Recarregado mensalmente na bilheteira ou a bordo dos autocarros",
        monthlyConditionsD: "Válido para o mês e Origem/Destino para o qual foi adquirido com número de viagens ilimitadas",
        monthlyConditionsE: "Tem de ser validado a bordo do autocarro",
        monthlyRequirements: "Documentos necessários:",
        monthlyRequirementA: "Cartão de Cidadão",
        monthlyRequirementB: "1 fotografia",
        passCIM: "PASSE SOCIAL CIM",
        passCIMConditions: "Detalhes:",
        passCIMConditionA: "Título personalizado, pessoal e intransmissível",
        passCIMConditionB: "Vendido na bilheteira",
        passCIMConditionC: "Recarregado mensalmente na bilheteira ou a bordo dos autocarros",
        passCIMConditionD: "Válido para o mês e Origem/Destino para o qual foi adquirido com número de viagens ilimitadas",        passCIMConditionE: "Tem de ser validado a bordo do autocarro",
        passCIMConditionF: "Título previamente autorizado pela CIMAC",
        passCIMConditionG: "Desconto face ao preço do Passe Mensal",
        passCIMRequirements: "Documentos necessários:",
        passCIMRequirementA: "Cartão de Cidadão",
        passCIMRequirementB: "1 fotografia",
        pass418s23: "PASSE SUB18+TP E SUB23+TP",
        pass418Conditions1: "Destinam-se a todas as crianças e jovens, dos 4 aos 23 anos (inclusive).",
        pass418Conditions2: "Beneficiam deste Passe os jovens com idade entre os 4 e os 23 anos, sendo o mesmo válido até ao último dia do mês em que completam 24 anos. Este passe não tem necessidade de renovação anual.",
        pass418Conditions3: "Condições de adesão conforme Portaria n.o 7-A/2024, de 05 de janeiro, alterada pela Portaria 307-A/2024/1 que regulamenta os passes gratuitos).",
        pass418ConditionA: "Título personalizado, pessoal e intransmissível",
        pass418ConditionB: "Vendido na bilheteira",
        pass418ConditionC: "Tem de ser validado a bordo do autocarro",
        pass418ConditionD: "Os passes são para os percursos/deslocações habituais casa – escola/trabalho",
        pass418ConditionE: "Cada jovem só tem direito a requisitar um passe gratuito",
        pass418ConditionF: "Caso a deslocação casa—escola / trabalho abranja mais que uma Comunidade Intermunicipal / Área Metropolitana o passageiro tem de fazer prova de que reside e estuda / trabalha em regiões diferentes e contíguas",
        pass418ConditionFA: "A prova de residência é a Certidão de Domicílio Fiscal obtida junto da Autoridade Tributária",
        pass418ConditionFB: "A prova de estudo é a Declaração de Matrícula emitida pelo estabelecimento de ensino",
        pass418ConditionFC: "A prova de trabalho é um documento comprovativo do local de trabalho emitido pela entidade patronal",
        pass418ConditionG: "Os passes são válidos até ao último dia do mês em que o titular completa 24 anos",
        pass418Requirements: "Documentos necessários:",
        pass418RequirementA: "Preenchimento do “Requerimento De Adesão – Passe Gratuito Para Jovens“ do IMT (formulário)",
        pass418RequirementB: "Apresentação do Cartão de Cidadão ou documento semelhante que comprove a data de nascimento",
        pass418RequirementC: "1 fotografia",
        pass418RequirementD: "Caso abranja mais que uma Comunidade Intermunicipal / Área Metropolitana (independentemente da idade), entregar comprovativo de morada de residência habitual e declaração de matrícula da instituição de ensino onde estuda ou documento comprovativo do local de trabalho emitido pela entidade patronal, conforme a Portaria 307-A/2024/1",
        pass418Notes: "Notas:",
        pass418NotesA: "O valor do novo cartão é suportado pelo passageiro, conforme a Portaria 7A/2024",
        pass418NotesB: "É obrigatório preencher/fornecer no ato de aquisição do passe toda a informação solicitada, em especial o documento de identificação civil (Cartão de Cidadão, Passaporte, etc) e o Número de Identificação Fiscal (NIF). Sem estes 2 dados não é permitida a emissão do passe",
        pass418NotesC: "Apesar de gratuitos os passes têm obrigatoriamente de ser sempre validados ao embarcar no autocarro. Sem passe é efetuada cobrança de bilhete de bordo",
        pass418Renewal: "Tem de ser renovado todos os anos.",
        passCircula: "PASSE CIRCULA PT",
        passCirculaConditionA: "Título personalizado, pessoal e intransmissível",
        passCirculaConditionB: "Vendido na bilheteira",
        passCirculaConditionC: "Recarregado mensalmente na bilheteira ou a bordo dos autocarros",
        passCirculaConditionD: "Válido para o mês e Origem/Destino para o qual foi adquirido com número de viagens ilimitadas",
        passCirculaConditionE: "Tem de ser validado a bordo do autocarro",
        passCirculaConditionF: "CIRCULA PT é um passe que garante descontos até 50%",
        passCirculaConditionG: "Esta nova modalidade, está regulamentada pela Portaria 322-A/2024/1, que estabelece 2 Escalões de desconto (A e B) nos Preços de Venda ao Público.",
        passCirculaDiscounts: "Beneficiários e Descontos",
        passCirculaDiscountsA: "Escalão A – 50% de Desconto",
        passCirculaDiscountsAA: "Beneficiários do Complemento Solidário para Idosos",
        passCirculaDiscountsAB: "Beneficiários do Rendimento Social de Inserção",
        passCirculaDiscountsAC: "Portadores de Atestado Médico de Incapacidade Multiusos (AMIM) com grau ≥ 60%",
        passCirculaDiscountsB: "Escalão B – 25% de Desconto",
        passCirculaDiscountsBA: "Reformados e pensionistas com rendimentos mensais iguais ou inferiores a 644,56€",
        passCirculaDiscountsBB: "Beneficiários do Subsídio de Desemprego, Subsídio Social de Desemprego, Subsídio por Cessação de Atividade e Subsídio por Cessação de Atividade Profissional com montante mensal igual ou inferior a 644,56€",
        passCirculaDiscountsBC: "Agregados familiares com rendimento médio mensal iguais ou inferiores a 644,56€",
        passCirculaRequirements: "Documentos necessários:",
        passCirculaRequirementA: "Cartão de Cidadão e Número de Contribuinte",
        passCirculaRequirementB: "1 fotografia",
        passCirculaRequirementC: "Declaração de rendimentos e nota de liquidação (quando aplicável)",
        passCirculaRequirementD: "Declaração que ateste o número de elementos do agregado familiar",
        passCirculaRequirementE: "Cópia do AMIM (se aplicável)",
        passAntigoCombatente: "PASSE ANTIGOS COMBATENTES",
        passAntigoCombatenteConditionA: "Título personalizado, pessoal e intransmissível",
        passAntigoCombatenteConditionB: "Válido para o mês e Origem/Destino para o qual foi adquirido com número de viagens ilimitadas",
        passAntigoCombatenteConditionC: "Tem de ser validado a bordo do autocarro",
        passAntigoCombatenteConditionD: "Destina-se a todos/as antigos/as combatentes, detentores do cartão de antigo combatente, bem como para a viúva ou viúvo do/a antigo/a combatente",
        passAntigoCombatenteConditionE: "O Passe de Antigo Combatente fica sujeito ao carregamento/ativação mensal",
        passAntigoCombatenteConditionF: "Pode ser carregado para o mês seguinte a partir do dia 25 e a qualquer altura para o mês vigente",
        passAntigoCombatenteConditionG: "O percurso que deve constar do passe é da paragem mais próxima da residência até ao destino habitual",
        passAntigoCombatenteConditionH: "O(A) beneficiário(a) do Passe de Antigo Combatente não pode usufruir da gratuitidade de mais que um título em simultâneo",
        passAntigoCombatenteMoreInfo: "Para mais informações aceda ao seguinte link:",
        passAntigoCombatenteLink: "Passe de Antigo Combatente (imt-ip.pt)",
        passAntigoCombatenteRequirements: "Documentos necessários:",
        passAntigoCombatenteRequirementA: "Cartão de cidadão ou outro título válido equivalente",
        passAntigoCombatenteRequirementB: "1 fotografia",
        passAntigoCombatenteRequirementC: "Cartão de antigo combatente ou cartão de viúva e viúvo de antigo combatente",
        passAntigoCombatenteRequirementD: "Formulário IMT devidamente preenchido e a certidão de domicílio fiscal emitida pela Autoridade Tributária aqui",
        ticketsDownload: "Consulte a Tabela Tarifária",
    }
});

export const changeLanguage = (languageKey) => {
    strings.setLanguage(languageKey);
}
